import React, { useState } from 'react'
import '../../style/Sidebar.css'
import '../../style/layout.css'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../features/loginSlice';
import api from '../../services/api';
import Cookies from 'js-cookie';

import profileImage from '../../images/profile.png'
import logo from '../../images/logo-white.png'

import { RiListOrdered2 } from "react-icons/ri";
import { MdSpaceDashboard } from "react-icons/md";
import { FaCartPlus } from "react-icons/fa";
import { useTranslation } from 'react-i18next';


const Sidebar = ({isOpen, onClose}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const user = useSelector(state => state.login.data)
    const profilePictureUrl = user ? user.profilePictureUrl : null

    const getActiveItem = () => {
        if (location.pathname.match(/^\/dashboard\/(all|Tests|Facilities)$/) || location.pathname.match(/^\/facility\/\d+$/) || location.pathname.match(/^\/Tests\/\d+$/)) return 'dashboard';
        if (location.pathname === '/my-orders' || location.pathname === '/order-details') return 'orders';
        if (location.pathname === '/cart') return 'cart';
        if (location.pathname === '/') return 'home';
        return '';
    };

    const activeItem = getActiveItem();

/**
     * Logs out the user and navigates to home.
     */
    const Signout = async () => {
        try {
            // Invalidate refresh token on backend so mobile sessions are also terminated
            const refreshToken = Cookies.get('refreshToken');
            if (refreshToken) {
                await api.post('/auth/logout', { refreshToken });
            }
        } catch (e) {
            // Proceed with local logout even if backend call fails
        } finally {
            Cookies.remove('jwt');
            Cookies.remove('refreshToken');
            Cookies.remove('userRole');
            Cookies.remove('healthFacility');
            dispatch(logout());
            navigate('/');
        }
    }


    return (
        <aside className={`container s
            `}>
            <div className='sub-menu-container mt-2 md:mt-10'>
                <ul>
                    <li className={`bars ${activeItem === 'dashboard' ? 'active' : ''}`}>
                        <Link to='/dashboard/All' className='sidebar-link'>
                            <MdSpaceDashboard color={'white'} size={28}/>
                            <p className='link-text'>{t('sidebar.dashboard')}</p>
                        </Link>
                    </li>
                    <li className={`bars ${activeItem === 'orders' ? 'active' : ''}`}>
                        <Link to='/my-orders' className='sidebar-link'>
                            <RiListOrdered2 color={'white'} size={28}/>
                            <p className='link-text'>{t('sidebar.orders')}</p>
                        </Link>
                    </li>
                    <li className={`bars ${activeItem === 'cart' ? 'active' : ''}`}>
                        <Link to='/cart' className='sidebar-link'>
                            <FaCartPlus color={'white'} size={26}/>
                            <p className='link-text'>{t('sidebar.cart')}</p>
                        </Link>
                    </li>
                </ul>
            </div>

            <div className='profile-box'>
                <Link to="/account" className="h-12 w-12 lg:h-16 lg:w-16 flex items-center justify-center rounded-full border-2 border-white bg-gray-200">
                    <img className='object-cover max-h-full max-w-full w-full h-full rounded-full' src={profilePictureUrl ? profilePictureUrl : profileImage} alt='Profile'/>
                </Link>
                <p className='signout' onClick={Signout}>{t('sidebar.sign_out')}</p>
            </div>

        </aside>
    )
}

export default Sidebar
